import { ItemType, ITEM } from '../config/items';

/**
 * 한 캐릭터(플레이어/봇/원격)의 활성 지속효과 상태머신.
 * 동시에 하나의 효과만 보유한다(설계 §4). apply는 항상 교체.
 * 폭탄은 즉발이라 이 상태머신을 거치지 않는다.
 */
export class PlayerEffect {
  private type: ItemType | null = null;
  private expiresAt: number = 0;

  /** 효과 적용/교체. durationMs 생략 시 효과별 지속시간(없으면 기본값). */
  apply(type: ItemType, now: number, durationMs?: number): void {
    const d = durationMs ?? ITEM.durationByType[type] ?? ITEM.durationMs;
    this.type = type;
    this.expiresAt = now + d;
  }

  /** 만료 처리. now 기준 만료됐으면 해제. */
  update(now: number): void {
    if (this.type !== null && now >= this.expiresAt) {
      this.type = null;
      this.expiresAt = 0;
    }
  }

  clear(): void {
    this.type = null;
    this.expiresAt = 0;
  }

  getActiveType(): ItemType | null {
    return this.type;
  }

  remainingMs(now: number): number {
    return this.type === null ? 0 : Math.max(0, this.expiresAt - now);
  }

  /** 원격 동기화 수신용: 남은시간으로 직접 설정 */
  setFromRemote(type: ItemType | null, remainingMs: number, now: number): void {
    if (type === null || remainingMs <= 0) {
      this.clear();
      return;
    }
    this.type = type;
    this.expiresAt = now + remainingMs;
  }

  // === 파생 게터 (Player/AIBot/Enemy 공용) ===

  speedMultiplier(): number {
    switch (this.type) {
      case 'invincible': return ITEM.invincibleSpeedMul;
      case 'giant': return ITEM.giantSpeedMul;
      case 'mini': return ITEM.miniSpeedMul;
      case 'slow': return ITEM.slowSpeedMul;
      default: return 1;
    }
  }

  sizeMultiplier(): number {
    switch (this.type) {
      case 'giant': return ITEM.giantSizeMul;
      case 'mini': return ITEM.miniSizeMul;
      default: return 1;
    }
  }

  isInvincible(): boolean {
    return this.type === 'invincible';
  }

  isReversed(): boolean {
    return this.type === 'reverse';
  }

  isRainbow(): boolean {
    return this.type === 'invincible';
  }
}
